import { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import './FunctionSearchDropdown.css';
import formatParamName from '../../../../utils/formatParamName';

function FunctionSearchDropdown({ functions = [], value = '', onSelect }) {
    const selectedFn = functions.find((fn) => fn.call_name === value);
    const [query, setQuery] = useState(selectedFn ? formatParamName(selectedFn.call_name) : '');
    const [open, setOpen] = useState(false);
    const [dropdownPos, setDropdownPos] = useState({});
    const inputRef = useRef();
    const containerRef = useRef();

    useEffect(() => {
        if (selectedFn) setQuery(formatParamName(selectedFn.call_name));
        else if (!value) setQuery('');
    }, [functions, value]);

    const filtered = query.trim()
        ? functions.filter((fn) =>
            fn.call_name.toLowerCase().includes(query.toLowerCase()) ||
            formatParamName(fn.call_name).toLowerCase().includes(query.toLowerCase())
          )
        : functions;

    const openDropdown = () => {
        if (inputRef.current) {
            const rect = inputRef.current.getBoundingClientRect();
            const estimatedHeight = 200;
            const spaceBelow = window.innerHeight - rect.bottom;
            const flipUp = spaceBelow < estimatedHeight && rect.top > estimatedHeight;
            setDropdownPos({
                position: 'fixed',
                top: flipUp ? 'auto' : rect.bottom,
                bottom: flipUp ? window.innerHeight - rect.top : 'auto',
                left: rect.left,
                width: rect.width,
            });
            inputRef.current.select();
        }
        setOpen(true);
    };

    const handleSelect = (e, fn) => {
        e.stopPropagation();
        setQuery(formatParamName(fn.call_name));
        setOpen(false);
        onSelect(fn);
    };

    const onInputChange = (e) => {
        setQuery(e.target.value);
        setOpen(true);
    };

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        if (!open) return;
        const handleScroll = (e) => {
            if (e.target.classList && e.target.classList.contains('function_dropdown_list')) return;
            setOpen(false);
        };
        window.addEventListener('scroll', handleScroll, true);
        return () => window.removeEventListener('scroll', handleScroll, true);
    }, [open]);

    return (
        <div className="function_row_dropdown" ref={containerRef}>
            <input
                ref={inputRef}
                className="function_search_input"
                type="text"
                placeholder="Choose a function"
                value={query}
                onChange={onInputChange}
                onFocus={openDropdown}
                onClick={openDropdown}
            />
            {open && filtered.length > 0 && createPortal(
                <div className="interface">
                    <ul className="function_dropdown_list" style={dropdownPos}>
                        {filtered.map((fn) => (
                            <li key={fn.call_name} onMouseDown={(e) => handleSelect(e, fn)}>
                                {formatParamName(fn.call_name)}
                            </li>
                        ))}
                    </ul>
                </div>,
                document.body
            )}
        </div>
    );
}

export default FunctionSearchDropdown;
